var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"containerNotFound"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v(" La dirección que intentas acceder no existe. ")]),_c('div',{staticClass:"circle small"}),_c('div',{staticClass:"circle medium"}),_c('div',{staticClass:"circle big"})])
}]

export { render, staticRenderFns }